module.exports = __webpack_public_path__ + "img/send-message-dm.c41ea0f6.svg";